import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ProfilesTableNew } from '../components/profiles/ProfilesTableNew'
import { axiosGet } from '../util/api'
import { Button } from '../components/ui/button'
import { Dialog } from '../components/ui/dialog'
import { BreadcrumbProps, Classes } from '@blueprintjs/core'
import { Layout } from '../components/Layout'

export const SettingsNew = observer(() => {
    const [refreshLoading, setRefreshLoading] = useState(false)
    const [reloadToken, setReloadToken] = useState(0)
    const [missingOpen, setMissingOpen] = useState(false)

    const handleRefresh = () => {
        setRefreshLoading(true)
        axiosGet('profiles/refresh')
            .then(() => {
                setReloadToken((t) => t + 1)
                setRefreshLoading(false)
            })
            .catch(() => setRefreshLoading(false))
    }

    const breadcrumbs: BreadcrumbProps[] = [{ text: 'Settings' }]

    return (
        <>
            <Layout
                breadcrumbs={breadcrumbs}
                primary="Data Connections"
                rightActions={
                    <>
                        <button
                            type="button"
                            onClick={() => setMissingOpen(true)}
                            className="text-[13px] text-[#7289A3] hover:text-[#0E2947] transition-colors"
                        >
                            Missing an account?
                        </button>
                        <Button
                            outlined
                            text="Refresh"
                            icon="refresh"
                            loading={refreshLoading}
                            onClick={handleRefresh}
                        />
                    </>
                }
            >
                <div className="max-w-3xl mx-auto mb-4">
                    <div className="pb-8 pt-3">
                        <h1 className="m-0 text-[24px] font-[700] leading-none tracking-[-0.03em] text-[#242529]">
                            Data Connections
                        </h1>
                        <p className="mt-1 mb-0 text-[14px] font-[400] leading-5 text-[#777A80]">
                            Manage the ad accounts connected to Merch Jar.
                        </p>
                    </div>
                    <ProfilesTableNew reloadToken={reloadToken} />
                </div>
            </Layout>

            {/* Missing account modal */}
            <Dialog
                isOpen={missingOpen}
                onClose={() => setMissingOpen(false)}
                title="Missing an account?"
                style={{ width: '540px' }}
            >
                <div className={Classes.DIALOG_BODY}>
                    <p className="text-[14px] text-[#0E2947] leading-relaxed">
                        Amazon will sometimes show accounts linked on the advertising platform, but
                        they will not be linked in the API (which Merch Jar uses to pull
                        information). This causes those accounts to not show up. To fix that, you
                        can manually link the account in Amazon, which will get it to show up for
                        the API.
                    </p>
                    <ol className="list-decimal ml-5 mt-3 space-y-1.5 text-[14px] text-[#0E2947]">
                        <li>
                            Go to&nbsp;
                            <a
                                target="_blank"
                                href="https://advertising.amazon.com/am/managerAccounts/list"
                                rel="noreferrer"
                                className="text-[#3391FF] hover:underline break-all"
                            >
                                https://advertising.amazon.com/am/managerAccounts/list
                            </a>
                        </li>
                        <li>
                            Click <strong>Create a Manager Account</strong>
                        </li>
                        <li>Type in an account name</li>
                        <li>
                            Click <strong>Advertiser</strong> as the account type
                        </li>
                        <li>
                            Add the account that is missing in MerchJar under the Link accounts area
                        </li>
                        <li>
                            Click <strong>Create Manager account</strong>
                        </li>
                        <li>
                            Click the <strong>Refresh</strong> button at the top of this page
                        </li>
                    </ol>
                    <p className="mt-3 text-[14px] text-[#7289A3]">
                        Any newly linked profiles will be added and Merch Jar will start pulling in
                        your data.
                    </p>
                </div>
            </Dialog>
        </>
    )
})
